// extracted by mini-css-extract-plugin
export default {"sidenav":"SideNav_sidenav__ILPqo","navItem":"SideNav_navItem__6Jda2","navTitle":"SideNav_navTitle__VxTUz"};